@if (swapPoint(); as swapPoint) {
  <app-swap-modal-summary-item-status
    [type]="type()"
    [swap]="swap()"
    [swapPoint]="swapPoint"
    [identifierColor]="identifierColor()"
  ></app-swap-modal-summary-item-status>
}

<app-swap-modal-summary-item-details
  [type]="type()"
  [swap]="swap()"
  [identifierColor]="identifierColor()"
></app-swap-modal-summary-item-details>

<app-swap-modal-summary-item-unassigned-points
  [type]="type()"
  [swap]="swap()"
  [identifierColor]="identifierColor()"
  [isDouble]="isDouble()"
></app-swap-modal-summary-item-unassigned-points>
